export default {
  data() {
    return {
      isMobileView: false,
      isTabletView: false,
      isDesktopView: false,
    };
  },
  computed: {
    isMobile() {
      return this.isMobileView;
    },
    isTablet() {
      return this.isTabletView;
    },
    isDesktop() {
      return this.isDesktopView;
    },
  },
  mounted() {
    const mobileQuery = window.matchMedia("(max-width: 767px)");
    const desktopQuery = window.matchMedia("(min-width: 1024px)");

    const update = () => {
      this.isMobileView = mobileQuery.matches;
      this.isDesktopView = desktopQuery.matches;
      this.isTabletView = !this.isMobileView && !this.isDesktopView;
    };

    mobileQuery.addEventListener("change", update);
    desktopQuery.addEventListener("change", update);
    update();

    this._mediaQueryCleanup = () => {
      mobileQuery.removeEventListener("change", update);
      desktopQuery.removeEventListener("change", update);
    };
  },
  beforeDestroy() {
    if (this._mediaQueryCleanup) {
      this._mediaQueryCleanup();
    }
  },
};
